import React from "react"
import Styles from "@/components/MultiFinshProductBundle/styles/ProductActionsUI.module.scss"
import debounce from "lodash/debounce"

import Button from "@/components/core/Button/Button"
import QuantitySelector from "@/components/cart/QuantitySelector"
import alertSmall from "@/public/icons/alert-small.svg"

const ProductActionsUI = props => {
  const {
    quantity = 1,
    loading = false,
    handleChange = () => {},
    staticTexts = {},
    isAllProductsAvailable = false,
    handleAddToCart = () => {},
  } = props || {}

  const {
    outOfStockAlert = "",
    addToCartLabel = "",
    addToCartNote = "",
  } = staticTexts

  return (
    <div className={Styles.ProductActionsUIWrapper}>
      {!isAllProductsAvailable ? (
        <div className={`out-of-stock-alert`}>
          <img className="alert-icon" alt="alert icon" src={alertSmall.src} />
          {outOfStockAlert}
        </div>
      ) : null}

      <div className="add-cart-container">
        <div className="quantity-selector-container">
          <QuantitySelector
            isPDPQuantitySelector={true}
            doNotRequiredAnalyticsData={true}
            isAddToCart={true}
            value={quantity}
            loading={loading}
            onChange={handleChange}
          />
        </div>

        <div className="add-to-cart-container">
          <Button
            label={addToCartLabel}
            role="button"
            size="large"
            type="primary"
            flexible={true}
            disabled={
              loading ||
              !quantity ||
              parseInt(quantity) < 1 ||
              !isAllProductsAvailable
            }
            loading={loading}
            onClick={debounce(handleAddToCart, 500)}
          />
        </div>
      </div>

      <p className="note">{addToCartNote}</p>
    </div>
  )
}

export default ProductActionsUI
